import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "settings-advanced-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.06 3.06a2.75 2.75 0 013.88 0c.35.34.58.75.7 1.19H21a.75.75 0 010 1.5h-2.35a2.75 2.75 0 01-5.3 0H3a.75.75 0 010-1.5h10.35c.13-.44.36-.85.7-1.2zm1.06 1.06a1.25 1.25 0 111.76 1.76 1.25 1.25 0 01-1.76-1.76zM21 12.75H10.65a2.75 2.75 0 01-5.3 0H3a.75.75 0 010-1.5h2.35a2.75 2.75 0 014.59-1.2c.35.35.58.76.7 1.2H21a.75.75 0 010 1.5zm-13.88.13a1.25 1.25 0 010-1.76 1.25 1.25 0 110 1.76zM18.65 19.75a2.75 2.75 0 01-5.3 0H3a.75.75 0 010-1.5h10.35a2.75 2.75 0 014.59-1.2c.35.35.58.76.7 1.2H21a.75.75 0 010 1.5h-2.35zm-1.4-.75a1.25 1.25 0 00-2.13-.88 1.25 1.25 0 102.13.88z"
    }, null, -1)
  ])))
}
export default { render: render }